// extracted by mini-css-extract-plugin
export default {"btnPrimary":"Home_btnPrimary__cVR96"};